<template>
  
  <div class="md-layout content" :class="{striped: !action}">
    <div class="md-layout-item md-size-10 title">
      {{ title }}
    </div>
    <div class="md-layout-item md-size-70 data-column">
      <div class="md-layout">
        <slot name="content"></slot>
      </div>
    </div>
    <div class="md-layout-item md-size-20">
      <slot name="validation"></slot>
    </div>
  </div>

</template>
<script>
export default {
  name: "group-card-row",
  props: {
    title: {
      type: String,
      default: "",
    },
    action: {
      type: Boolean,
      default: false,
    }
  },
};
</script>
<style scoped lang="scss">
  @import "../../assets/scss/theme.scss";
  
  .striped:nth-child(even){
    /* background: rgba(0,0,0,0.04);
    border-radius: 5px; */
  }
  .striped{
    /* border-bottom: 1px solid rgba(0,0,0,0.2); */
  }
  .title{
    text-align: end;
    color: $color-primary;
    font-weight: bold;
  }
  .data-column{
    border-left:  1px solid rgba(0,0,0,0.2);
    border-right: 1px solid rgba(0,0,0,0.2);
    /* padding-bottom: 15px; */
  }
  .content > *{
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>
